import React from 'react';
import styled from '@emotion/styled';
import GoogleMaps from '../../../../src/components/GoogleMaps.png';
import { Result } from '../types';
const OuterWrap = styled.div`
  width: 600px;
  height: 400px;
  margin-top: 30px;
  margin-bottom:30px;
  margin-left: 35px;
`;
const HeaderInfo = styled.div`
  font-weight: bold;
  margin-top: 8px;
  background: #f7f7f9;
  border-radius: 6px 6px 0px 0px;
  padding: 24px 16px;
  font-size: 18px;
  border-bottom: 1px solid #e5e5ea;
`;
interface Props {
  property: Result;
}
const StreetViewMap = (props: Props) => {
  return (
    <OuterWrap>
      <HeaderInfo>
        Google Maps Street View
        <a
          href={`https://www.google.com/maps/place/${props.property?.address}+${props.property?.muniTypes[0].name}+${props.property?.muniTypes[0].state}+${props.property?.location.zip}`}
          target="_blank"
          rel="noreferrer"
        >
          <img src={GoogleMaps} style={{ width: 27, height: 27, marginLeft: 32 }} alt="" />
        </a>
      </HeaderInfo>
      <img
        src={`https://maps.googleapis.com/maps/api/streetview?size=600x400&location=${props.property?.address}+${props.property?.muniTypes[0].name}+${props.property?.muniTypes[0].state}+${props.property?.location.zip}&key=AIzaSyDdwIQVthZdvbv3VeX_EgUUV4Kp6PHd-Ks`}
        alt=""
      ></img>
    </OuterWrap>
  );
};

export default StreetViewMap;
